import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class ConnectionService {
  connectionLost: EventEmitter<any> = new EventEmitter();

  readonly NO_ERRORS = 0;
  readonly CONNECTION_LOST = 1;
  readonly SERVER_ERROR = 2;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/services/connection.service.ts